<template>
<div class="chapter">
<div class="inner_page">
<p class="C920"><span id="id_8">CONTENTS </span></p>
<p class="C924"><em><a href="#/html/08_Acknowle#id_9">Acknowledgments</a> </em></p>
<p class="C925"><a href="#/html/09_Introduc#page_1">Introduction: Bad Ideas</a></p>
<p class="C926"><a href="#/html/10_1_The_Gr#page_19"><span class="space">1</span>The Grand Collision of Spring 1950</a></p>
<p class="C926"><span href="#/html/11_2_A_Mono#page_49" title="Link target outside of Sample"><span class="space">2</span>A Monolithic Oneness</span></p>
<p class="C926"><span href="#/html/12_3_The_Ba#page_79" title="Link target outside of Sample"><span class="space">3</span>The Battle over Lysenkoism</span></p>
<p class="C926"><span href="#/html/13_4_Experi#page_106" title="Link target outside of Sample"><span class="space">4</span>Experiments in Rehabilitation</span></p>
<p class="C926"><span href="#/html/14_5_Skirmi#page_135" title="Link target outside of Sample"><span class="space">5</span>Skirmishes on the Edge of Creation</span></p>
<p class="C926"><span href="#/html/15_6_Strang#page_163" title="Link target outside of Sample"><span class="space">6</span>Strangest Bedfellows</span></p>
<p class="C927"><span href="#/html/16_Conclusi#page_195" title="Link target outside of Sample">Conclusion: Pseudoscience in Our Time</span></p>
<p class="C925"><em><span href="#/html/17_Abbrevia#page_213" title="Link target outside of Sample">Abbreviations and Archives</span> </em></p>
<p class="C927"><em><span href="#/html/18_Notes#page_215" title="Link target outside of Sample">Notes</span> </em></p>
<p class="C927"><em><span href="#/html/19_Index#page_281" title="Link target outside of Sample">Index</span> </em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?b5714602